export default function noop() {
  /* no-op */
}
